import { z } from 'zod';

import { PROJECT_ROLE } from '../enums';

import { idSchema } from './common';

export const projectKeySchema = z
  .string()
  .trim()
  .toUpperCase()
  .regex(
    /^[A-Z][A-Z0-9]{1,9}$/,
    'Key must be 2–10 uppercase letters/digits starting with a letter',
  );

export const createProjectInputSchema = z.object({
  name: z.string().trim().min(2).max(80),
  key: projectKeySchema,
  description: z.string().max(1000).optional(),
});
export type CreateProjectInput = z.infer<typeof createProjectInputSchema>;

export const updateProjectInputSchema = z.object({
  name: z.string().trim().min(2).max(80).optional(),
  description: z.string().max(1000).nullable().optional(),
  leadUserId: idSchema.nullable().optional(),
  archived: z.boolean().optional(),
});
export type UpdateProjectInput = z.infer<typeof updateProjectInputSchema>;

export const projectSummarySchema = z.object({
  id: idSchema,
  name: z.string(),
  key: projectKeySchema,
  description: z.string().nullable(),
  memberCount: z.number().int().nonnegative(),
  openIssueCount: z.number().int().nonnegative(),
  archivedAt: z.string().nullable(),
  role: z.enum([PROJECT_ROLE.LEAD, PROJECT_ROLE.MEMBER, PROJECT_ROLE.VIEWER]).nullable(),
});
export type ProjectSummary = z.infer<typeof projectSummarySchema>;
